/**
 * @format
 */

import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Advertisement, FullCategory } from '../../api/adserver';
import Divider from '../../components/Divider';

import CategoryListItem from './CategoryListItem';

export interface Props {
  advertCategoryList?: FullCategory[];
  onPress?: (item: Advertisement, category: FullCategory) => void;
  onPressCategory?: (item: FullCategory) => void;
}

const CategoryListRender: React.FC<Props> = (props) => {
  if (!props.advertCategoryList) {
    return null;
  }
  return (
    <>
      {props.advertCategoryList.map((category) => {
        return (
          <View key={category.title}>
            <CategoryListItem
              item={category}
              onPress={(item: Advertisement) =>
                props.onPress && props.onPress(item, category)
              }
              onPressCategory={props.onPressCategory}
            />
            <Divider containerStyle={styles.divider} large />
          </View>
        );
      })}
    </>
  );
};

const styles = StyleSheet.create({
  divider: {
    marginLeft: -15,
    width: 2000,
    marginTop: 10,
  },
});

export default CategoryListRender;
